import React, { useCallback, useEffect, useRef, useState } from "react";
import { ReactTyped as Typed } from "react-typed";
import { FaReact, FaNodeJs } from "react-icons/fa";
import { SiJavascript, SiHtml5, SiCss3, SiMongodb } from "react-icons/si";
import "./Home.css";
import miFoto from "../assets/PantallaInicio.png";

const MOBILE_TEXT_BREAKPOINT = 700;
const PARTICLES_BREAKPOINT = 750;
const PARTICLES_RETRY_DELAY = 250;
const PARTICLES_MAX_RETRIES = 12;

const skills = [
  { name: "React", icon: <FaReact color="#61DBFB" size={40} /> },
  { name: "JavaScript", icon: <SiJavascript color="#F7DF1E" size={40} /> },
  { name: "HTML", icon: <SiHtml5 color="#E44D26" size={40} /> },
  { name: "CSS", icon: <SiCss3 color="#1572B6" size={40} /> },
  { name: "Node.js", icon: <FaNodeJs color="#68A063" size={40} /> },
  { name: "MongoDB", icon: <SiMongodb color="#4DB33D" size={40} /> },
];

const aboutMeText = `Desde que vi mi primer ordenador supe que quería formar parte del mundo digital. Hoy me dedico a crear aplicaciones web y móviles, transformando ideas en productos reales. Actualmente llevo en producción una app de ligas de dardos con más de 300 usuarios activos y sigo formándome en el campus 42 Málaga. Si tienes una idea y quieres hacerla realidad, estaré encantado de ayudarte.`;

const Home = () => {
  const [verMas, setVerMas] = useState(false);
  const [esMovil, setEsMovil] = useState(window.innerWidth <= MOBILE_TEXT_BREAKPOINT);
  const particlesHostRef = useRef(null);
  const particlesRetryTimeoutRef = useRef(null);
  const particlesDisabledRef = useRef(window.innerWidth <= PARTICLES_BREAKPOINT);

  const destroyParticles = useCallback(() => {
    if (particlesRetryTimeoutRef.current) {
      window.clearTimeout(particlesRetryTimeoutRef.current);
      particlesRetryTimeoutRef.current = null;
    }

    if (Array.isArray(window.pJSDom)) {
      window.pJSDom.forEach((instance) => instance?.pJS?.fn?.vendors?.destroypJS?.());
      window.pJSDom = [];
    }

    if (particlesHostRef.current) {
      particlesHostRef.current.innerHTML = "";
    }
  }, []);

  const initializeParticles = useCallback((attempt = 0) => {
    if (window.innerWidth <= PARTICLES_BREAKPOINT || !particlesHostRef.current) {
      destroyParticles();
      return;
    }

    if (!window.particlesJS) {
      if (attempt >= PARTICLES_MAX_RETRIES) {
        return;
      }

      particlesRetryTimeoutRef.current = window.setTimeout(() => {
        initializeParticles(attempt + 1);
      }, PARTICLES_RETRY_DELAY);
      return;
    }

    destroyParticles();
    window.particlesJS.load("particles-js", "/particles.json");
  }, [destroyParticles]);

  useEffect(() => {
    initializeParticles();

    const handleResize = () => {
      setEsMovil(window.innerWidth <= MOBILE_TEXT_BREAKPOINT);

      const particlesDisabled = window.innerWidth <= PARTICLES_BREAKPOINT;
      if (particlesDisabled !== particlesDisabledRef.current) {
        particlesDisabledRef.current = particlesDisabled;
        if (particlesDisabled) {
          destroyParticles();
        } else {
          initializeParticles();
        }
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      destroyParticles();
    };
  }, [destroyParticles, initializeParticles]);

  const textoCorto = aboutMeText.slice(0, 250) + "...";

  return (
    <>
      <div id="about" className="hero-section">
        <div id="particles-js" ref={particlesHostRef} className="particles" aria-hidden="true"></div>
        <div className="home-content">
          <div className="homeHeader">
            <img className="homePortrait" src={miFoto} alt="Foto de Juanmi" />
            <div className="speechBubble">
              <h1 className="TextTittle titulo-animado">¡Hola! Soy Juanmi</h1>
              <Typed
                className="react-typed"
                strings={[
                  "Desarrollo Web y Apps",
                  "Transformo ideas en realidad",
                  "Estudiante en 42 Málaga",
                  "¿Tienes un proyecto en mente?",
                ]}
                typeSpeed={200}
                backSpeed={100}
                loop
              />
            </div>
          </div>
          <div className="AboutMe">
            <h2 className="TextTittle">Sobre mí</h2>
            <p>
              {esMovil && !verMas ? textoCorto : aboutMeText}
              {esMovil && (
                <span
                  className="ver-mas-btn"
                  style={{ color: "#61DBFB", cursor: "pointer", marginLeft: "8px" }}
                  onClick={() => setVerMas(!verMas)}
                >
                  {verMas ? "Ver menos" : "Ver más..."}
                </span>
              )}
            </p>
          </div>
          <div className="skills">
            {skills.map((skill, index) => (
              <div key={index} className="skill modern-skill">
                {skill.icon}
                <span className="skill-name">{skill.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
